import React, { useEffect } from 'react';
import Contact from '../components/Contact';

import ai_and_ml_banner from '../assets/ai_and_ml_banner.jpg'
import ai_and_ml from '../assets/ai_and_ml.jpg'

const AIMachineLearning = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      {/* Hero Section */}
      <div className='mt-20 relative'>
        <div className='relative mt-[6rem]'>
          <img
            className='w-full h-[40rem] object-cover blur-sm'
            src={ai_and_ml_banner}
            alt='AI & Machine Learning at Jyotinay Analytics'
          />
          <div className='container mx-auto absolute inset-0 flex flex-col items-center justify-center px-4 text-center'>
            <p className='text-white text-3xl md:text-5xl font-bold'>
              AI & Machine Learning at Jyotinay Analytics
            </p>
            <p className='text-white text-base md:text-xl mt-4 md:mt-8 max-w-3xl'>
              From intelligent automation to predictive modeling, our AI and ML solutions help your business think smarter, act faster, and scale with precision.
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className='container mx-auto mt-12 px-4'>
        <div className='max-w-3xl mx-auto text-left'>
          <p className='text-base md:text-lg leading-relaxed'>
            At Jyotinay Analytics, we don’t just follow trends — we build them. Our AI and Machine Learning
            services equip your business with the ability to learn from data, identify patterns, and automate
            decisions with unparalleled accuracy.
          </p>

          <img
            className='w-full md:w-[30rem] h-[15rem] object-cover mt-8 rounded-lg shadow-md mx-auto'
            src={ai_and_ml}
            alt='AI and Machine Learning Services'
          />

          {/* Why AI & ML Section */}
          <div className='mt-12'>
            <h2 className='text-xl md:text-2xl font-semibold mb-4'>
              Why AI & ML Matter for Your Business
            </h2>

            <p className='mb-4 text-base md:text-lg leading-relaxed'>
              AI and ML are transforming how businesses operate — from recommendation systems and intelligent
              chatbots to fraud detection and supply chain optimization. The key? Having a partner who can
              tailor these capabilities to your specific goals.
            </p>

            <p className='mb-6 text-base md:text-lg leading-relaxed'>
              Our experts at Jyotinay Analytics specialize in creating end-to-end AI/ML pipelines that
              integrate seamlessly with your existing systems, empowering you to scale with speed and
              confidence.
            </p>

            <ul className='list-disc ml-6 space-y-2 text-base md:text-lg'>
              <li>Custom machine learning model development</li>
              <li>Predictive analytics for business forecasting</li>
              <li>Natural Language Processing (NLP) & chatbot integration</li>
              <li>Intelligent automation and anomaly detection</li>
              <li>AI strategy consulting and model deployment</li>
            </ul>
          </div>
        </div>

        
      </div>
      {/* Contact Form */}
      <Contact />
    </div>
  );
};

export default AIMachineLearning;
